import { StorageService } from './../../common/services/storage.service';
import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

import { AdminService } from "../../../app/a-dashboard/service/api/admin.service";
import { SessionService } from "../../../app/common/services/session.service";
import { SubjectService } from "../../../app/common/services/subject.service";
import { GlobalSearchService } from "../../../app/global-search/service/api/global-search.service";
import { RemaindersService } from "../../../app/shared/component/remainders/service/api/remainders.service";
import { LANG_LIST } from "../../multi-lang/multi-lang";
import { SharedService } from "../../shared/service/api/shared.service";
import { TopBarMenu,SystemAdminTopBar } from "../constants/menu.constant";

// import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.scss"],
})
export class TopbarComponent implements OnInit {
  userProfileData: any;
  userProfile: boolean = false;
  MenuItem = [];
  userInfo: any;
  userRole:any;
  notification: boolean = false;
  //@Output() MenuToggler = new EventEmitter();
  toggleLeft: boolean = false;
  left = "50px";
  isVirtualView = false;
  permission: any;
  //remainder
  remainderFlag: boolean = false;
  remainderData: any;
  remainderCount: any;
  selectedDate: Date;
  todaysDate = new Date();
  calenderFlag: boolean = false;
  filterFlag: boolean = false;
  instanceConfig: any = {};
  hideFlag: boolean = false;
  remainderHideFlag: boolean = false;

  // Global search
  searchName = "";

  // Multi Language

  languages: any[];
  selectedLang: string;
  languageList: any[];
  // supportLanguage: ["en", "mr", "hi"];

  langObj = {
    MDashboard: "Dashboard",
    MRegister: "Register",
    MSchedule: "Schedule",
    MCall: "Call",
    MComplaints: "Complaints",
    MVisitors: "Visitors",
  };

  menuArr = TopBarMenu;
  systemArr = SystemAdminTopBar;

  constructor(
    private ss: SessionService,
    private router: Router,
    private service: GlobalSearchService,
    private subSession: SubjectService,
    private adminApi: AdminService,
    private remainderService: RemaindersService,
    private titleService: Title,
    public translate: TranslateService,
    private sharedService: SharedService,
    private storage: StorageService
  ) {
    this.userInfo = this.ss.getUserInfo();
    this.userRole = this.userInfo.role
    this.subSession.selectedLang.subscribe((res: any) => {
      this.translate.get("Menulist").subscribe((data: any) => {
        this.langObj = data;
        this.permission = this.ss.getAuthPermission();
        this.setMenus();
      });
    });

    this.userProfileData = {};
    this.languageList = LANG_LIST;

    // this.setMultiLang();
  }

  getSignInData() {
    this.userProfileData = this.ss.getUserInfo();
  }

  // toggleSideBar() {
  //   if (window.outerWidth < 897) {
  //     this.MenuToggler.emit('mobile');
  //     this.setLeft();
  //   } else {
  //     this.MenuToggler.emit('web');
  //     this.setLeft();
  //   }
  // }

  setLeft() {
    if (this.toggleLeft === false) {
      this.left = "200px";
      this.toggleLeft = true;
    } else {
      this.left = "50px";
      this.toggleLeft = false;
    }
  }

  toggleEvent(input) {
    if (input === "notification") {
      this.notification = !this.notification;
    } else if (input === "user-profile") {
      this.userProfile = !this.userProfile;
    }
  }

  menuClickHandle(menu) {
    if (this.isVirtualView) {
      let vv = this.ss.getSessionVirtualViewId();
      if (vv.id === "ALL" && menu.label === "Dashboard") {
        this.router.navigate(["/viewer-dashboard"]);
        return;
      }
    }

    if (
      menu.label === "Dashboard" &&
      this.userInfo &&
      this.userInfo.role === "KARYA_KARTA"
    ) {
      this.router.navigate(["/karyakarta/dashboard"]);
      return;
    }
    if (
      menu.label === "Dashboard" &&
      this.userInfo &&
      this.userInfo.role === "VIEWER"
    ) {
      this.router.navigate(["/viewer-dashboard"]);
      return;
    }

    this.router.navigate([menu.link]);
  }

  setMenus() {
    let TopBarMenu = {
      DASHBOARD: {
        key: "DASHBOARD",
        label: this.langObj.MDashboard,
        icon: "pi pi-pw pi-home pi-th-large",
        link: "/admin-dashboard",
        rank: 1,
      },
      SUPER_ADMIN_DASHBOARD: {
        key: "SUPER_ADMIN_DASHBOARD",
        label: this.langObj.MDashboard,
        icon: "pi pi-pw pi-home pi-th-large",
        link: "/admin-dashboard",
        rank: 1,
      },
      SYSTEM_ADMIN_DASHBOARD: {
        key: "DASHBOARD",
        label: this.langObj.MDashboard,
        icon: "pi pi-pw pi-home pi-th-large",
        link: "/admin-dashboard",
        rank: 1,
      },
      OFFICE_ADMIN_DASHBOARD: {
        key: "DASHBOARD",
        label: this.langObj.MDashboard,
        icon: "pi pi-pw pi-home pi-th-large",
        link: "/admin-dashboard",
        rank: 1,
      },
      KARYAKARTA_DASHBOARD: {
        key: "DASHBOARD",
        label: this.langObj.MDashboard,
        icon: "pi pi-pw pi-home pi-th-large",
        link: "/karyakarta/dashboard",
        rank: 1,
      },
      VIEWER_DASHBOARD: {
        key: "DASHBOARD",
        label: this.langObj.MDashboard,
        icon: "pi pi-pw pi-home pi-th-large",
        link: "/viewer-dashboard",
        rank: 1,
      },

      REGISTER_BOOK: {
        key: "REGISTER_BOOK",
        label: this.langObj.MRegister,
        icon: "pi pi-pw pi-briefcase",
        link: "/register-book/list",
        rank: 2,
      },
      SCHEDULE_BOOK: {
        key: "SCHEDULE_BOOK",
        label: this.langObj.MSchedule,
        icon: "pi pi-pw pi-calendar",
        link: "/shedule-book/list",
        rank: 3,
      },
      COMPLAINTS: {
        key: "COMPLAINTS",
        label: this.langObj.MComplaints,
        icon: "pi pi-pw pi-info-circle",
        link: "/complain/list",
        rank: 4,
      },
      CALL_LOGS: {
        key: "CALL_LOGS",
        label: this.langObj.MCall,
        icon: "pi pi-pw pi-comments",
        link: "/call-log",
        rank: 6,
      },
      VISITORS: {
        key: "VISITORS",
        label: this.langObj.MVisitors,
        icon: "pi pi-pw pi-users",
        link: "/visitor/list",
        rank: 5,
      },
    };
    let SystemAdminTopBar = [
      // {
      //   key: "DASHBOARD",
      //   label: this.langObj.MDashboard,
      //   icon: "pi pi-pw pi-home pi-th-large",
      //   link: "/admin-dashboard",
      //   rank: 1,
      // },
      {
        key: "SUPER_ADMIN_DASHBOARD",
        label: this.langObj.MDashboard,
        icon: "pi pi-pw pi-home pi-th-large",
        link: "/admin-dashboard",
        rank: 1,
      },
    ]
    if(this.userRole == "SYSTEM_ADMIN"){
      this.MenuItem = SystemAdminTopBar;
    }else{
      this.permission.map((elePer) => {
          if (TopBarMenu[elePer.name]) {
            this.MenuItem.push(TopBarMenu[elePer.name]);
          }
      });
    }
    
    this.MenuItem.sort(function (rank1, rank2) {
      return rank1.rank - rank2.rank;
    });
    return this.MenuItem;
  }

  globalSearch(data, event) {
    if (data.valid) {
      this.router.navigate(["/global/search"], {
        queryParams: { search: this.searchName, event: event },
      });
    }
  }

  // private permissions() {
  //   this.permission = this.ss.getAuthPermission();
  //   this.setMenus();
  // }

  ClearSearchData() {
    this.searchName = "";
    this.router.navigate(["/admin-dashboard"]);
  }

  showList() {
    this.remainderFlag = true;
  }

  notificationList() {
    let dateObj: any;
    if (this.selectedDate != undefined) {
      let Date = this.dateFormat(this.selectedDate);
      dateObj = { date: Date };
    } else {
      let Date = this.dateFormat(this.todaysDate);
      dateObj = { date: Date };
    }

    this.remainderService.remaindersList(dateObj).subscribe((res: any) => {
      this.remainderData = res[0];
      this.remainderCount = res[1];
    });
  }

  // Filter Data
  clearFilter() {
    this.selectedDate = null;
    this.calenderFlag = false;
    this.filterFlag = false;
    this.notificationList();
  }

  selectDate() {
    this.calenderFlag = true;
  }

  handelSubmit(date) {
    this.filterFlag = true;
    this.selectedDate = date;
    this.notificationList();
  }

  dateFormat(recievedDate) {
    let date = recievedDate;
    let d = date.getDate();
    let m = date.getMonth() + 1;
    let y = date.getFullYear();
    recievedDate =
      y + "-" + (m <= 9 ? "0" + m : m) + "-" + (d <= 9 ? "0" + d : d);
    return recievedDate;
  }

  setDashboard() {
    if (this.userInfo.role == "SUPER_ADMIN") {
      this.router.navigate(["/admin-dashboard"]);
    } else if (this.userInfo.role == "SYSTEM_ADMIN") {
      this.router.navigate(["/admin-dashboard"]);
    } else if (this.userInfo.role == "OFFICE_ADMIN") {
      this.router.navigate(["/admin-dashboard"]);
    } else if (this.userInfo.role == "KARYA_KARTA") {
      this.router.navigate(["/karyakarta/dashboard"]);
    } else if (this.userInfo.role == "VIEWER") {
      this.router.navigate(["/viewer-dashboard"]);
    }
  }

  // Multi Language

  // setMultiLang() {
  //   this.translate.addLangs(this.languageList);
  //   let lang;
  //   if (this.ss.isLanguage()) {
  //     lang = this.ss.getLanguage();
  //   } else {
  //     lang = this.translate.getBrowserLang();
  //   }
  //   this.ss.setLanguage(lang);
  //   this.sub.selectedLang.next(lang);
  //   this.translate.setDefaultLang(lang);
  //   this.translate.use(lang);
  // }

  changeLangEvent(lang) {
    this.translate.use(lang);
    // this.sub.selectedLang.next(lang);
    // this.ss.setLanguage(lang);
  }

  logout() {
    this.router.navigate(["/login"]);
    this.storage.flushStorage();
  }

  ngOnInit() {
    // this.permissions();
    this.isVirtualView = this.ss.isVirtualView();
    this.userInfo = this.ss.getUserInfo();
    //this.isVirtualView = this.sessionService.isVirtualView();
    this.notificationList();

    this.subSession.globalSearchName.subscribe((res: any) => {
      this.searchName = res.name;
      if (this.searchName == undefined) {
        this.searchName = "";
      }
    });

    if (this.userInfo.role == "KARYA_KARTA") {
      this.hideFlag = false;
    }

    if (
      this.userInfo.role == "SUPER_ADMIN" ||
      this.userInfo.role == "OFFICE_ADMIN"
    ) {
      this.remainderHideFlag = true;
    }

    setTimeout(() => {
      this.getSignInData();
    });
    this.processInstanceConfig();
  }

  private processInstanceConfig() {
    this.instanceConfig = this.ss.getInstanceConfig();

    if (this.instanceConfig) {
      this.titleService.setTitle(this.instanceConfig.BRANDING_PAGE_TITLE);
    } else {
      this.instanceConfig = {};
    }
  }
}
